/**
 * 页尾指令
 */
/**
 */

define('directives/common/footer/footer.directives',['app', 'mainCons'], function (app, mainCons) {
    app.directive('opFooter', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/common/footer/footer.template.html',
            link: function ($scope, element, attrs) {

                $scope.contractUs = function () {
                    AUI.BaseJSUtil.redirectUrlByBlank(sysUrlCfg.documentHref.contractUs);
                }
                $scope.privacyPolicy = function () {
                    AUI.BaseJSUtil.redirectUrlByBlank(sysParamCfg.footer.privacyPolicy);
                }
                $scope.termsOfUse = function () {
                    AUI.BaseJSUtil.redirectUrlByBlank(sysUrlCfg.documentHref.termsOfUse);
                }
                $scope.clickCookies = function () {
                    AUI.BaseJSUtil.redirectUrlByBlank(sysParamCfg.footer.cookies);
                }
                $scope.clickCookiesSetting = function () {
                    AUI.BaseJSUtil.redirectUrlByBlank(sysParamCfg.footer.cookiesUrlAnchor);
                }
                $scope.copyright = sysParamCfg.footer.desc;
            }
        }
    }]);
});

